import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import styled from 'styled-components';
import { SearchField } from '@purpurds/purpur/search-field';
import { purpurColorFunctionalWhite, purpurColorGray100, purpurColorPurple200 } from '@purpurds/tokens/color/variables';
import { purpurShadowMd } from '@purpurds/tokens/shadow/variables';
import spacing from 'theme/spacing';
const SearchProductContainer = styled.div `
  display: flex;
  flex-direction: column;
  width: 95%;
  height: 100%;
  margin: ${spacing.spacing12} ${spacing.spacing8};
`;
const SearchFieldContainer = styled.div `
  width: 100%;
`;
const ProductItemList = styled.ul `
  margin-top: ${spacing.spacing8};
  padding: 0;
  list-style: none
`;
const ProductItem = styled.li `
  cursor: pointer;
  margin: ${spacing.spacing8} 0;
  padding: ${spacing.spacing16};
  border-radius: ${spacing.spacing4};
  border: 1px solid ${purpurColorGray100};
  box-shadow: ${purpurShadowMd};
  background-color: ${purpurColorFunctionalWhite};

  &:hover {
    background: ${purpurColorPurple200};
  }
`;
export const SearchProductBar = ({ options, onChange }) => {
    const [query, setQuery] = useState('');
    const filteredOptions = useMemo(() => {
        return options.filter(option => option.name.toLowerCase().includes(query.toLowerCase()));
    }, [options, query]);
    return (_jsxs(SearchProductContainer, { children: [_jsx(SearchFieldContainer, { children: _jsx(SearchField, { clearButtonAriaLabel: "Clear", onChange: (e) => setQuery(e.target.value), onClear: () => setQuery(''), placeholder: "S\u00F8k i produktlisten", searchButtonLabel: "S\u00F8k", value: query, variant: "button-attached" }) }), _jsx(ProductItemList, { children: filteredOptions.map(option => (_jsx(ProductItem, { onClick: () => onChange(option), children: option.name }, option.value))) }), filteredOptions.length === 0 && (_jsx("div", { children: "Ingen resultater." }))] }));
};
